import { SET_DESKTOP_MENU_SHADOW, SET_DESKTOP_MENU_OPEN_STATE } from '../../mutation-types';

export function setShadow({ commit }, { hasBigShadow }) {
    commit(SET_DESKTOP_MENU_SHADOW, { hasBigShadow });
}

export function open({ commit }) {
    commit(SET_DESKTOP_MENU_OPEN_STATE, { isOpen: true });
}

export function close({ commit }) {
    commit(SET_DESKTOP_MENU_OPEN_STATE, { isOpen: false });
}

export function toggle({ commit, state }) {
    commit(SET_DESKTOP_MENU_OPEN_STATE, { isOpen: !state.isOpen });
}
